
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function PressPage() {
  const pressReleases = [
    {
      id: 1,
      date: '2024-12-15',
      title: 'BNM Raises ₹50 Crores in Series A Funding to Expand Home Services Platform',
      excerpt: 'Baainearme (BNM) announces successful Series A funding round led by prominent investors to accelerate growth across Maharashtra and expand service offerings.',
      category: 'Funding',
      readTime: '3 min read'
    },
    {
      id: 2,
      date: '2024-11-28',
      title: 'BNM Partners with 10,000+ Service Providers Across Nagpur',
      excerpt: 'Platform achieves major milestone with over 10,000 verified service partners, delivering quality home services to thousands of families.',
      category: 'Milestone',
      readTime: '2 min read'
    },
    {
      id: 3,
      date: '2024-10-20',
      title: 'BNM Launches AI-Powered Service Matching Technology',
      excerpt: 'New intelligent matching system connects customers with the most suitable service providers based on location, skills, and customer preferences.',
      category: 'Product',
      readTime: '4 min read'
    },
    {
      id: 4,
      date: '2024-09-15',
      title: 'BNM Wins "Best Startup of the Year" at Maharashtra Innovation Awards',
      excerpt: 'Recognition for innovative approach to solving home service challenges and creating employment opportunities for skilled workers.',
      category: 'Awards',
      readTime: '2 min read'
    },
    {
      id: 5,
      date: '2024-08-10',
      title: 'BNM Expands Service Categories with Beauty and Wellness',
      excerpt: 'Platform now offers comprehensive beauty and wellness services at home, partnering with certified professionals across Nagpur.',
      category: 'Product',
      readTime: '3 min read'
    },
    {
      id: 6,
      date: '2024-07-05',
      title: 'BNM Achieves 50,000+ Happy Customers Milestone',
      excerpt: 'Platform celebrates serving over 50,000 satisfied customers with quality home services, maintaining 4.8-star average rating.',
      category: 'Milestone',
      readTime: '2 min read'
    }
  ];

  const mediaKit = [
    {
      type: 'Logo Package',
      description: 'High-resolution BNM logos in various formats',
      size: '2.5 MB',
      icon: 'ri-image-line'
    },
    {
      type: 'Brand Guidelines',
      description: 'Complete brand identity and usage guidelines',
      size: '1.8 MB',
      icon: 'ri-book-line'
    },
    {
      type: 'Product Screenshots',
      description: 'High-quality app and website screenshots',
      size: '5.2 MB',
      icon: 'ri-smartphone-line'
    },
    {
      type: 'Executive Photos',
      description: 'Professional headshots of leadership team',
      size: '3.1 MB',
      icon: 'ri-user-star-line'
    }
  ];

  const awards = [
    {
      year: '2024',
      award: 'Best Startup of the Year',
      organization: 'Maharashtra Innovation Awards',
      category: 'Technology Innovation'
    },
    {
      year: '2024',
      award: 'Rising Star in Home Services',
      organization: 'India Startup Awards',
      category: 'Consumer Services'
    },
    {
      year: '2024',
      award: 'Excellence in Digital Platform',
      organization: 'Nagpur Business Excellence Awards',
      category: 'Digital Innovation'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
               style={{
                 backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20newsroom%20with%20journalists%20and%20press%20conference%20setup%2C%20media%20coverage%20and%20news%20broadcasting%2C%20purple%20and%20white%20corporate%20theme%2C%20professional%20press%20event%2C%20success%20and%20media%20attention%20concept&width=1200&height=600&seq=press-hero&orientation=landscape')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Press & Media
            </h1>
            <p className="text-xl mb-8">
              Latest news, press releases, and media resources about BNM
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-newspaper-line mr-2"></i>
                <span>Latest News</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-download-line mr-2"></i>
                <span>Media Kit</span>
              </div>
              <div className="flex items-center bg-white/20 px-4 py-2 rounded-full">
                <i className="ri-award-line mr-2"></i>
                <span>Awards</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Press Releases */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Latest Press Releases</h2>
            <p className="text-xl text-gray-600">Stay updated with BNM's journey</p>
          </div>

          <div className="max-w-4xl mx-auto space-y-8">
            {pressReleases.map((release) => (
              <article key={release.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-sm text-gray-500">
                        {new Date(release.date).toLocaleDateString('en-US', { 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}
                      </span>
                      <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-medium">
                        {release.category}
                      </span>
                      <span className="text-sm text-gray-500 flex items-center">
                        <i className="ri-time-line mr-1"></i>
                        {release.readTime}
                      </span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-3 hover:text-purple-600 cursor-pointer">
                      {release.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">{release.excerpt}</p>
                  </div>
                  <button className="bg-purple-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap mt-4 md:mt-0 md:ml-6">
                    Read More
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Media Kit */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Media Kit</h2>
            <p className="text-xl text-gray-600">Resources for journalists and media professionals</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {mediaKit.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className={`${item.icon} text-purple-600`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.type}</h3>
                      <p className="text-gray-600 mb-2">{item.description}</p>
                      <span className="text-sm text-gray-500">{item.size}</span>
                    </div>
                  </div>
                  <button className="bg-purple-600 text-white p-2 rounded-lg hover:bg-purple-700 transition-colors cursor-pointer">
                    <i className="ri-download-line"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <button className="bg-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-700 transition-colors cursor-pointer whitespace-nowrap">
              Download Complete Media Kit
            </button>
          </div>
        </div>
      </section>

      {/* Awards & Recognition */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Awards & Recognition</h2>
            <p className="text-xl text-gray-600">Acknowledgments for our innovative approach</p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="grid gap-6">
              {awards.map((award, index) => (
                <div key={index} className="bg-purple-50 rounded-xl p-6 border border-purple-100">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-16 h-16 bg-purple-600 text-white rounded-full flex items-center justify-center mr-6">
                        <i className="ri-award-line text-2xl"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-1">{award.award}</h3>
                        <p className="text-purple-600 font-medium mb-1">{award.organization}</p>
                        <p className="text-gray-600 text-sm">{award.category}</p>
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-purple-600">
                      {award.year}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Key Statistics */}
      <section className="py-16 bg-purple-600 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">BNM by Numbers</h2>
            <p className="text-xl">Key statistics for media coverage</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">50,000+</div>
              <p className="text-purple-100">Happy Customers</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">10,000+</div>
              <p className="text-purple-100">Service Partners</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">200,000+</div>
              <p className="text-purple-100">Services Completed</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">4.8★</div>
              <p className="text-purple-100">Average Rating</p>
            </div>
          </div>
        </div>
      </section>

      {/* Media Contact */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Media Contact</h2>
          <p className="text-xl text-gray-600 mb-8">
            For press inquiries, interviews, and media requests
          </p>
          
          <div className="max-w-2xl mx-auto">
            <div className="bg-purple-50 rounded-2xl p-8 border border-purple-100">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-contacts-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Media Relations Team</h3>
              
              <div className="space-y-4">
                <div className="flex items-center justify-center">
                  <i className="ri-mail-line text-purple-600 mr-3"></i>
                  <a href="mailto:press@baainearme.com" className="text-gray-700 hover:text-purple-600 cursor-pointer">
                    press@baainearme.com
                  </a>
                </div>
                
                <div className="flex items-center justify-center">
                  <i className="ri-phone-line text-purple-600 mr-3"></i>
                  <a href="tel:93074 19845" className="text-gray-700 hover:text-purple-600 cursor-pointer">
                    +91 93074 19845
                  </a>
                </div>
                
                <div className="flex items-center justify-center">
                  <i className="ri-time-line text-purple-600 mr-3"></i>
                  <span className="text-gray-700">Available Mon-Fri, 9 AM - 6 PM IST</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Revolutionizing home services across India
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Press</h3>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">Press Releases</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Media Kit</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Awards</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/careers" className="hover:text-white cursor-pointer">Careers</Link></li>
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Media</h3>
              <ul className="space-y-2 text-gray-400">
                <li>📧 press@baainearme.com</li>
                <li>📞 +91 93074 19845</li>
                <li>📍 Nagpur, Maharashtra</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
